/* eslint-disable @typescript-eslint/no-unused-vars */
import { ErrorStatus } from '@/components/inputs';
import { Loadable } from '@/components/loaders';
import { CongratulationScreen } from '@/global/components/CongratulationScreen';
import { DataSource, DataSourceSFTPConfig } from '@/models/dataSource';
import { useAppDispatch, useAppSelector } from '@/reducers';
import { useSaveDataSourceMutation } from '@/services/dataSources';
import { FC, useEffect } from 'react';
import { stashDataSource } from '@/features/dataSources/dataSourcesSlice';

type SFTPConfigurationCompletedProps = {
  onInit?: VoidFunction;
  onNextStep?: VoidFunction;
  onPrevStep?: VoidFunction;
  onCancel?: VoidFunction;
  isModal?: boolean;
};

export const SFTPConfigurationCompletedStep: FC<SFTPConfigurationCompletedProps> = ({ onInit, onNextStep, onPrevStep, isModal }) => {
  const dispatch = useAppDispatch();

  const dataSource = useAppSelector((state) => state.dataSources.edit?.dataSource) as Partial<DataSource<DataSourceSFTPConfig>> | undefined;

  const [_, { isLoading, error: dataSourceError, data: savedDataSource }] = useSaveDataSourceMutation();

  useEffect(() => {
    if (savedDataSource) {
      dispatch(stashDataSource(savedDataSource.dataSource));
    }
  }, [savedDataSource]);

  useEffect(() => {
    onInit();
  }, []);

  if (dataSourceError) {
    return <ErrorStatus error={(dataSourceError as any).error} />;
  }

  return dataSource && dataSource.name && dataSource.configuration ? (
    <Loadable isLoading={isLoading}>
      <CongratulationScreen
        title='data_source_edit.code.installation_success.data_source_created_succesfully'
        subtitle='data_source_edit.code.installation_success.data_source_created_succesfully_subtitle'
        primaryButton={
          isModal
            ? {
                text: 'data_source_edit.code.installation_success.choose_destination',
                onClick: onNextStep,
              }
            : {
                text: 'data_source_edit.code.installation_success.create_new_campaing',
                onClick: onNextStep,
              }
        }
        secondaryButton={
          isModal
            ? {
                text: 'data_source_edit.code.installation_success.add_another_data_source',
                onClick: onPrevStep,
              }
            : {
                text: 'data_source_edit.code.installation_success.view_all_data_sources',
                onClick: onPrevStep,
              }
        }
      />
    </Loadable>
  ) : null;
};
